import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Spin } from 'antd';
import { Bar } from 'react-chartjs-2';
import axios from 'axios';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const CAuditoriaCliente = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem('user'));
  const empresaId = user?.user?.idCooperativa;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/auditoria/${empresaId}`,
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        setData(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };
  
    fetchData();
  }, []);

  // Transformar datos para Chart.js
  const transformDataForChart = (moduleData) => {
    if (!Array.isArray(moduleData)) {
      return {
        labels: ['Valor'],
        datasets: [
          {
            label: 'Cantidad',
            data: [moduleData],
            backgroundColor: '#FB6B48',
          },
        ],
      };
    }

    const dataObject = moduleData[0];
    const labels = [];
    const values = [];

    Object.entries(dataObject).forEach(([key, value]) => {
      if (key !== '_id') {
        labels.push(key.charAt(0).toUpperCase() + key.slice(1));
        values.push(value);
      }
    });

    return {
      labels,
      datasets: [
        {
          label: 'Cantidad',
          data: values,
          backgroundColor: '#FB6B48',
        },
      ],
    };
  };

  // Configuración de los módulos
  const modules = [
    { title: 'Administración', key: 'administracion' },
    { title: 'Cereales', key: 'cereales' },
    { title: 'Insumos', key: 'insumos' },
    { title: 'Divisas', key: 'divisas' },
    { title: 'Supermercado', key: 'supermercado' },
    { title: 'Cooperativa', key: 'cooperativa' },
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spin size="large" />
      </div>
    );
  }

  if (!data) {
    return <div>No hay datos disponibles</div>;
  }

  return (
    <div className="p-4">
      <Row gutter={[16, 16]}>
        {modules.map((module) => {
          const chartData = transformDataForChart(data[module.key]);

          return (
            <Col xs={24} sm={24} md={12} key={module.key}>
              <Card title={module.title} className="h-full" style={{ minHeight: '400px' }}>
                {chartData.labels && chartData.labels.length > 0 ? (
                  <Bar
                    data={chartData}
                    options={{
                      responsive: true,
                      plugins: {
                        legend: { position: 'top' },
                        title: { display: true, text: `Datos de ${module.title}` },
                      },
                    }}
                  />
                ) : (
                  <div>No hay datos para este módulo</div>
                )}
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default CAuditoriaCliente;